exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#device-scaled-page-container{width:100%;padding:20px;background-color:#fff}#device-scaled-page-container .device-scaled-page-content{margin-bottom:50px}#device-scaled-page-container .device-scaled-page-content .table-container{width:100%}#device-scaled-page-container .device-scaled-page-content .add-device-btn{margin:15px;margin-top:0}#device-scaled-page-container .device-scaled-page-content .edit-cell button{width:80%;margin-left:10%}#device-scaled-page-container .device-scaled-page-content .delete-cell{width:100%;font-size:20px;color:red;text-align:center}#device-scaled-page-container .device-scaled-page-content .row{padding-top:5px;padding-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/lib/loader.js!./styles/settings/devices/scaled.scss
// module id = 2178
// module chunks = 43